import { LiliAutoComplete } from '@lili/lili-frontend-common';
import { OnboardingFormFields } from '@Types/index';
import { ControllerWrapper } from '@Hooks/index';
import type { ListItem } from '@lili/lili-frontend-common';
import type { Country } from '@Types/country';
import type { FieldError } from 'react-hook-form';

interface IProps {
  tabIndex: number;
  countryList: ListItem[];
  disabled?: boolean;
  wrapperId?: string;
  onCountryChange?: (selectedCountryItem: ListItem, onChange: (value: ListItem) => void) => void;
}

interface extendedCountry extends Country {
  title: string;
  value: string;
}
export const CountryInput = ({ countryList, disabled, onCountryChange, tabIndex }: IProps) => {
  return (
    <ControllerWrapper name={OnboardingFormFields.COUNTRY}>
      {({
        onChange,
        value,
        onBlur,
        error,
      }: {
        onChange: (value: ListItem) => void;
        value: extendedCountry;
        onBlur: () => void;
        error?: FieldError;
      }) => {
        const selectedItemValue = value ? { title: value.name, value: value.code } : null;

        return (
          <div className='min-h-[76px] w-full'>
            <LiliAutoComplete
              disabled={disabled}
              placeholder={'Select Country'}
              onItemSelection={(item: { title: string; value: string }) => {
                if (onCountryChange) {
                  onCountryChange(item, onChange);
                } else {
                  onChange(item);
                }
              }}
              selectedItem={selectedItemValue}
              autoCompleteItems={countryList}
              tabIndex={tabIndex}
              onBlur={onBlur}
              errorMessage={error?.message}
            />
          </div>
        );
      }}
    </ControllerWrapper>
  );
};
